// extracted by mini-css-extract-plugin
export default {"continent":"Continent_continent__Amq68","container":"Continent_container__Z-tWs","img":"Continent_img__5F-+8","icon":"Continent_icon__vkHGC"};